import React, { useState } from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';
import menuSalad from '../images/menuSalad.webp'

const ModalMenuCardSalad = (args) => {
  
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  return (
    <div>
      <Button color="danger" onClick={toggle}>
      SPRAWDŹ
      </Button>
      <Modal isOpen={modal} toggle={toggle} {...args} className='modal-menu'>
        <ModalBody>
          <img src={menuSalad} alt='menu' className='modal-menu-img'/>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default ModalMenuCardSalad;